<template>
  <div v-if="viewMode" v-html="formatNumber(value)"></div>
  <div v-else>
    <input
      ref="input"
      type="text"
      class="number-input"
      v-model="content"
      @keypress="filter"
      :disabled="disabled"
      placeholder="_,_"
      @change="$emit('change', content.replace(',', '.'))"
    />
  </div>
</template>

<script>
export default {
  name: "bks-number",
  props: {
    formatgreek: { default: true, type: Boolean },
    value: { default: null },
    digits: { default: 2 },
    viewMode: { type: Boolean, default: false },
    disabled: { default: false, type: Boolean }
  },
  data() {
    return {
      initialValue:null,
      content: null
    };
  },
  created() {
    if (this.formatgreek)
      this.content = this.value ? (this.value + "").replace(",", ".") : "";
    else this.content = this.value;
    this.initialValue=""+this.content;
  },
  watch: {
    content: function(val, oldval) {
      // _log_("vhann....", val, oldval);
      // if (!val && !oldval) return;
      if (val != oldval) {
        // val = this.content = this.content.replace(",", ".");
        _log_("k.C." + this.content);
        this.$nextTick(() => {
          if (this.formatgreek) this.content = this.content.replace(".", ",");
        });
        this.$emit("input", val.replace(",", "."));
        // this.$emit("change", { val: val, oldval: oldval });
      } //{val:val,oldval:oldval})
    }
  },
  methods: {
    init() {},
    filter(event) {
     
      _log_("k.." + event.keyCode);
   
      if (
        (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
        // event.keyCode != 46 &&
        event.keyCode != 44
      ) {
        event.preventDefault();
      }
      if ( event.keyCode == 44) {//event.keyCode == 46 ||
        // _log_("k.C.F." + this.content);
        if (this.formatgreek && this.content.indexOf(",") > -1)
          event.preventDefault();
        // if (!this.formatgreek && this.content.indexOf(".") > -1)
        //   event.preventDefault();
      }
    }
  }
};
</script>
<style>
.number-input {
  /* border-radius: 4px; */
  background-color: unset;
  border: none;
  border-bottom: 1px solid #409eff;
}
</style>

